import styled from "styled-components";

export const Badge = styled.div`
  padding: 0.2rem 1rem;
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};
  border-radius: 10px;
  width: fit-content;
`;
